export default "__VITE_ASSET__czxC9rst__"